"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMissingCameraFlight = exports.isMissingAssets = exports.isRetryable = void 0;
const isRetryable = (responseStatus) => {
    return responseStatus !== undefined && (responseStatus >= 500 || responseStatus === 200);
};
exports.isRetryable = isRetryable;
const isMissingAssets = (data) => {
    return data !== undefined && (!data.assets || data.assets.length === 0);
};
exports.isMissingAssets = isMissingAssets;
const isMissingCameraFlight = (data) => {
    return data !== undefined && data.renderCameraFlight === true && !data.cameraFlightVideo;
};
exports.isMissingCameraFlight = isMissingCameraFlight;
